import { createSelector } from '@reduxjs/toolkit';
import type { MeetingViewModel } from '@trinnvis/dabih-api-client';
import { getOrganization } from '../organization/getOrganization';
import { toList } from '../toList';

export const meetingsNotDeleted = createSelector(getOrganization, (organization): MeetingViewModel[] => {
  if (organization === undefined) return [];
  return toList(organization.meetingsById)
    .filter((e) => !e.deleted)
    .filter((e) => e.templateId !== undefined)
    .filter((e) => e.templateId !== 10142);
});
